import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';

const Auctions = () => {
  return (
    <Layout
      headerMenu={false}
      onBack
      bottomMenu
    >
      <AppShell variant='full' padded={false}>
        <iframe
          className='embed-page'
          title='Subastas Montepio Luz Savinon'
          src='https://subastas.montepio.org.mx/'
        />
      </AppShell>
    </Layout>
  );
};

export default Auctions;
